import { Language } from '../i18n/LanguageContext';

export interface ProfileData {
  name: string;
  title: string;
  location: string;
  description: string;
  contact: {
    email: string;
    linkedin: string;
    github: string;
    website: string;
    gites: string;
  };
  experience: Array<{
    period: string;
    role: string;
    company: string;
    description: string[];
  }>;
  projects: Array<{
    name: string;
    description: string;
    technologies: string[];
    github?: string;
    website?: string;
    image?: string;
    stars?: number;
    forks?: number;
    license?: string;
  }>;
  skills: {
    cloud: string[];
    infrastructure: string[];
    data: string[];
    ai: string[];
    devops: string[];
    monitoring: string[];
    programmation: string[];
    management: string[];
  };
  certifications: Array<{
    year: string;
    name: string;
  }>;
  education: Array<{
    year: string;
    degree: string;
    school: string;
  }>;
  achievements: string[];
  interests: string[];
}

export const profileTranslations: Record<Language, ProfileData> = {
  fr: {
    name: "Patrick Szymkowiak",
    title: "Manager / Architecte d'Infrastructures Hybrides",
    location: "Lille, Hauts-de-France, France",
    description: "Ingénieur passionné par l'innovation technologique, je suis spécialisé dans la résolution de problématiques complexes et le pilotage de projets stratégiques. Mon leadership collaboratif et mes compétences en communication me permettent de fédérer des équipes pluridisciplinaires autour d'objectifs communs pour garantir la réussite de chaque projet.",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "Juin 2017 - Aujourd'hui",
        role: "PDG / Spécialiste Cloud / Infrastructure",
        company: "InnovTech",
        description: [
          "Création entreprise InnovTech spécialiste revendeurs Cloud providers (Azure, AWS, GCP) sur la région Hauts de France",
          "Prestations en direct sur des grandes comptes Internationaux",
          "Développement d'une solution open source de vérification d'infra en C#, docker",
          "MCSE : Cloud Platform and Infrastructure ; Certifications Azure : 532, 534, 533",
          "MCT : Microsoft Teacher. Réalisation de formations Microsoft az-104"
        ]
      },
      {
        period: "2024 - Aujourd'hui",
        role: "Fondateur",
        company: "Startups kexa.io & thecloudprices.com",
        description: [
          "kexa.io : vérification de la sécurité du système d'information des sociétés",
          "thecloudprices.com : estimation des prix des VMs des clouds providers",
          "Incubation Euratech 2024 programme de 6 mois pour kexa.io",
          "Accélération Euratech Cyber Campus 2025 pour kexa.io"
        ]
      },
      {
        period: "Janvier 2023 - Septembre 2024",
        role: "MLops",
        company: "Client Eurotunnel",
        description: [
          "Création de l'infrastructure data ml en terraform automatisé sur GitHub en CI/CD",
          "Déploiement d'Azure OpenAI",
          "Mise en place d'une solution de reconnaissance de véhicule python, yolo",
          "Mise en place d'un chat bot python / Azure OpenAI",
          "Projet de mise en place Kafka",
          "Debug de CI/CD GitHub. Gestion des selfhosted runner Azure scaleset, cloud-init"
        ]
      },
      {
        period: "Septembre 2021 - Octobre 2022",
        role: "Manager d'équipe cloud",
        company: "Client Auchan",
        description: [
          "Gestion d'équipe infrastructure de 30 personnes",
          "Gestion du portefeuille projet",
          "Gestion du budget de dépenses",
          "Gestion de la transformation d'externalisation de services de gestion"
        ]
      },
      {
        period: "Novembre 2019 - 2021",
        role: "Move to cloud",
        company: "Norauto International",
        description: [
          "Démarrage de souscription Azure avec création des scripts terraform. Landing zone",
          "Création d'architecture globale",
          "Mise en place d'infrastructure mutualisée pour les projets data",
          "Terraform, VM, Azure Databricks, PAAS PostgreSQL, storage, backup, patchs",
          "Travail sur les sujets data : spark, Azure Data Factory, Azure Data Lake"
        ]
      },
      {
        period: "Février 2018 - 2019",
        role: "Move to cloud",
        company: "Auchan Retail International",
        description: [
          "Accompagnement des 80 projets à l'international",
          "Création d'architecture globale",
          "Mise en place d'infrastructure mutualisée",
          "Terraform, VM, Kubernetes, PAAS PostgreSQL MySQL, storage, backup, patchs"
        ]
      },
      {
        period: "Dec 2016 - Juin 2017",
        role: "Service Delivery Manager",
        company: "SwissLife France",
        description: [
          "Responsable d'une équipe de 17 personnes",
          "Administration niveau 2",
          "Service base de données",
          "Équipe de production, mise en production"
        ]
      },
      {
        period: "2010 - Nov 2016",
        role: "Responsable Infrastructure",
        company: "SwissLife France",
        description: [
          "Projet de création d'un datacenter, virtualisation de 200 serveurs ; VMworld Europe 2014",
          "Projet de refonte du backup (TSM, Networker, Veeam, VDP VMware)",
          "Projet de cloud privé et automatisation VRA ; VMworld Europe 2016",
          "Projet d'infrastructure SAN / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "Projet de refonte du monitoring (Zabbix, Linux)",
          "Projet de refonte de la messagerie : Exchange 2013 pour 6000 comptes",
          "Management de 2 équipes de 11 personnes"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "Plateforme open-source d'alerting et de monitoring cloud avec règles simples. Vérification de sécurité du système d'information des entreprises. 316+ stars GitHub. Incubation Euratech 2024 et Accélération Cyber Campus 2025.",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "Entreprise InnovTech - Revendeur spécialisé Cloud providers (Azure, AWS, GCP) en région Hauts-de-France. Prestations directes pour grandes comptes internationaux et services de consulting cloud.",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "Outil d'estimation et comparaison en temps réel des prix des VMs des principaux cloud providers. Aide à l'optimisation des coûts d'infrastructure cloud (Azure, AWS, GCP).",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "Application de bureau moderne pour gérer les clusters Kubernetes avec clarté. Support multi-contexte, logs temps réel, terminaux interactifs. Built avec Tauri et Rust.",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "Architecture Multi-Cloud"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "Landing Zones"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "Machine Learning", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["Leadership", "Gestion d'équipe", "Gestion de projet", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Certifications Azure (532, 533, 534)" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS Télécom Infrastructure Réseaux (Bac+5)",
        school: "Université de Lille 1 (Sciences et Technologies)"
      },
      {
        year: "2002",
        degree: "Stage 6 mois aux USA",
        school: "Echo Web - Oregon"
      },
      {
        year: "2014",
        degree: "Management",
        school: "Formation professionnelle"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - Projet datacenter et virtualisation",
      "VMWorld Europe 2016 - Best Award pour cloud privé et automatisation",
      "22 ans d'expérience en infrastructure et cloud",
      "Incubation Euratech 2024",
      "Accélération Euratech Cyber Campus 2025",
      "316+ stars sur le projet Kexa (GitHub)",
      "1K+ followers LinkedIn",
      "Fondateur de plusieurs startups innovantes"
    ],

    interests: [
      "Funboard",
      "Wing foil",
      "Paddle",
      "Création de gîtes touristiques",
      "Cinéma"
    ]
  },

  en: {
    name: "Patrick Szymkowiak",
    title: "Manager / Hybrid Infrastructure Architect",
    location: "Lille, Hauts-de-France, France",
    description: "I am an engineer passionate about technological innovation, specializing in solving complex problems and leading strategic projects. My collaborative leadership and communication skills enable me to unite multidisciplinary teams around common goals to ensure the success of each project.",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "June 2017 - Present",
        role: "CEO / Cloud Specialist / Infrastructure",
        company: "InnovTech",
        description: [
          "Founded InnovTech, specialist Cloud provider reseller (Azure, AWS, GCP) in the Hauts de France region",
          "Direct services to large international accounts",
          "Development of an open source infrastructure verification solution in C#, docker",
          "MCSE: Cloud Platform and Infrastructure; Azure Certifications: 532, 534, 533",
          "MCT: Microsoft Teacher. Microsoft az-104 training delivery"
        ]
      },
      {
        period: "2024 - Present",
        role: "Founder",
        company: "Startups kexa.io & thecloudprices.com",
        description: [
          "kexa.io: IT security verification for companies",
          "thecloudprices.com: VM price estimation for cloud providers",
          "Euratech 2024 incubation - 6-month program for kexa.io",
          "Euratech Cyber Campus 2025 acceleration for kexa.io"
        ]
      },
      {
        period: "January 2023 - September 2024",
        role: "MLops",
        company: "Eurotunnel Client",
        description: [
          "Created data ml infrastructure with automated terraform on GitHub in CI/CD",
          "Azure OpenAI deployment",
          "Implemented vehicle recognition solution python, yolo",
          "Set up chatbot python / Azure OpenAI",
          "Kafka implementation project",
          "GitHub CI/CD debugging. Azure scaleset selfhosted runner management, cloud-init"
        ]
      },
      {
        period: "September 2021 - October 2022",
        role: "Cloud Team Manager",
        company: "Auchan Client",
        description: [
          "Management of infrastructure team of 30 people",
          "Project portfolio management",
          "Expenditure budget management",
          "Management services outsourcing transformation management"
        ]
      },
      {
        period: "November 2019 - 2021",
        role: "Move to Cloud",
        company: "Norauto International",
        description: [
          "Azure subscription startup with terraform script creation. Landing zone",
          "Global architecture creation",
          "Shared infrastructure setup for data projects",
          "Terraform, VM, Azure Databricks, PAAS PostgreSQL, storage, backup, patches",
          "Work on data topics: spark, Azure Data Factory, Azure Data Lake"
        ]
      },
      {
        period: "February 2018 - 2019",
        role: "Move to Cloud",
        company: "Auchan Retail International",
        description: [
          "Support of 80 international projects",
          "Global architecture creation",
          "Shared infrastructure setup",
          "Terraform, VM, Kubernetes, PAAS PostgreSQL MySQL, storage, backup, patches"
        ]
      },
      {
        period: "Dec 2016 - June 2017",
        role: "Service Delivery Manager",
        company: "SwissLife France",
        description: [
          "Manager of a team of 17 people",
          "Level 2 administration",
          "Database service",
          "Production team, deployment"
        ]
      },
      {
        period: "2010 - Nov 2016",
        role: "Infrastructure Manager",
        company: "SwissLife France",
        description: [
          "Datacenter creation project, virtualization of 200 servers; VMworld Europe 2014",
          "Backup redesign project (TSM, Networker, Veeam, VDP VMware)",
          "Private cloud and VRA automation project; VMworld Europe 2016",
          "SAN infrastructure project / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "Monitoring redesign project (Zabbix, Linux)",
          "Messaging redesign project: Exchange 2013 for 6000 accounts",
          "Management of 2 teams of 11 people"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "Open-source cloud alerting and monitoring platform with simple rules. IT security verification for companies. 316+ GitHub stars. Euratech 2024 Incubation and Cyber Campus 2025 Acceleration.",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "InnovTech Company - Specialized Cloud providers reseller (Azure, AWS, GCP) in Hauts-de-France region. Direct services for international large accounts and cloud consulting.",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "Real-time VM price estimation and comparison tool for major cloud providers. Helps optimize cloud infrastructure costs (Azure, AWS, GCP).",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "Modern desktop application to manage Kubernetes clusters with clarity. Multi-context support, real-time logs, interactive terminals. Built with Tauri and Rust.",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "Multi-Cloud Architecture"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "Landing Zones"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "Machine Learning", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["Leadership", "Team Management", "Project Management", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Azure Certifications (532, 533, 534)" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS Telecom Infrastructure Networks (Master's Degree)",
        school: "University of Lille 1 (Sciences and Technologies)"
      },
      {
        year: "2002",
        degree: "6-month internship in the USA",
        school: "Echo Web - Oregon"
      },
      {
        year: "2014",
        degree: "Management",
        school: "Professional Training"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - Datacenter and virtualization project",
      "VMWorld Europe 2016 - Best Award for private cloud and automation",
      "22 years of experience in infrastructure and cloud",
      "Euratech 2024 Incubation",
      "Euratech Cyber Campus 2025 Acceleration",
      "316+ stars on Kexa project (GitHub)",
      "1K+ LinkedIn followers",
      "Founder of several innovative startups"
    ],

    interests: [
      "Funboard",
      "Wing foil",
      "Paddle",
      "Tourist cottage creation",
      "Cinema"
    ]
  },

  // Les autres langues (es, de, ja, zh) suivront le même format...
  // Pour l'instant, je vais utiliser les traductions anglaises comme base
  es: {
    name: "Patrick Szymkowiak",
    title: "Gerente / Arquitecto de Infraestructuras Híbridas",
    location: "Lille, Altos de Francia, Francia",
    description: "Soy un ingeniero apasionado por la innovación tecnológica, especializado en resolver problemas complejos y liderar proyectos estratégicos. Mi liderazgo colaborativo y habilidades de comunicación me permiten unir equipos multidisciplinarios en torno a objetivos comunes para garantizar el éxito de cada proyecto.",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "Junio 2017 - Presente",
        role: "CEO / Especialista Cloud / Infraestructura",
        company: "InnovTech",
        description: [
          "Creación de la empresa InnovTech especialista en revendedores de proveedores Cloud (Azure, AWS, GCP) en la región de Altos de Francia",
          "Servicios directos a grandes cuentas internacionales",
          "Desarrollo de una solución de código abierto de verificación de infraestructura en C#, docker",
          "MCSE: Cloud Platform and Infrastructure; Certificaciones Azure: 532, 534, 533",
          "MCT: Microsoft Teacher. Realización de formaciones Microsoft az-104"
        ]
      },
      {
        period: "2024 - Presente",
        role: "Fundador",
        company: "Startups kexa.io & thecloudprices.com",
        description: [
          "kexa.io: verificación de la seguridad del sistema de información de las empresas",
          "thecloudprices.com: estimación de precios de VMs de proveedores cloud",
          "Incubación Euratech 2024 programa de 6 meses para kexa.io",
          "Aceleración Euratech Cyber Campus 2025 para kexa.io"
        ]
      },
      {
        period: "Enero 2023 - Septiembre 2024",
        role: "MLops",
        company: "Cliente Eurotunnel",
        description: [
          "Creación de infraestructura data ml con terraform automatizado en GitHub en CI/CD",
          "Despliegue de Azure OpenAI",
          "Implementación de solución de reconocimiento de vehículos python, yolo",
          "Implementación de chatbot python / Azure OpenAI",
          "Proyecto de implementación Kafka",
          "Depuración de CI/CD GitHub. Gestión de selfhosted runner Azure scaleset, cloud-init"
        ]
      },
      {
        period: "Septiembre 2021 - Octubre 2022",
        role: "Gerente de equipo cloud",
        company: "Cliente Auchan",
        description: [
          "Gestión de equipo de infraestructura de 30 personas",
          "Gestión de cartera de proyectos",
          "Gestión del presupuesto de gastos",
          "Gestión de la transformación de externalización de servicios de gestión"
        ]
      },
      {
        period: "Noviembre 2019 - 2021",
        role: "Migración a cloud",
        company: "Norauto International",
        description: [
          "Inicio de suscripción Azure con creación de scripts terraform. Landing zone",
          "Creación de arquitectura global",
          "Implementación de infraestructura compartida para proyectos data",
          "Terraform, VM, Azure Databricks, PAAS PostgreSQL, storage, backup, parches",
          "Trabajo en temas data: spark, Azure Data Factory, Azure Data Lake"
        ]
      },
      {
        period: "Febrero 2018 - 2019",
        role: "Migración a cloud",
        company: "Auchan Retail International",
        description: [
          "Acompañamiento de 80 proyectos internacionales",
          "Creación de arquitectura global",
          "Implementación de infraestructura compartida",
          "Terraform, VM, Kubernetes, PAAS PostgreSQL MySQL, storage, backup, parches"
        ]
      },
      {
        period: "Dic 2016 - Junio 2017",
        role: "Gerente de entrega de servicios",
        company: "SwissLife France",
        description: [
          "Responsable de un equipo de 17 personas",
          "Administración nivel 2",
          "Servicio de base de datos",
          "Equipo de producción, despliegue"
        ]
      },
      {
        period: "2010 - Nov 2016",
        role: "Gerente de infraestructura",
        company: "SwissLife France",
        description: [
          "Proyecto de creación de datacenter, virtualización de 200 servidores; VMworld Europe 2014",
          "Proyecto de rediseño de backup (TSM, Networker, Veeam, VDP VMware)",
          "Proyecto de cloud privado y automatización VRA; VMworld Europe 2016",
          "Proyecto de infraestructura SAN / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "Proyecto de rediseño de monitoreo (Zabbix, Linux)",
          "Proyecto de rediseño de mensajería: Exchange 2013 para 6000 cuentas",
          "Gestión de 2 equipos de 11 personas"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "Plataforma open-source de alertas y monitoreo cloud con reglas simples. Verificación de seguridad de sistemas de información empresariales. 316+ estrellas GitHub. Incubación Euratech 2024 y Aceleración Cyber Campus 2025.",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "Empresa InnovTech - Revendedor especializado en proveedores Cloud (Azure, AWS, GCP) en la región Hauts-de-France. Servicios directos para grandes cuentas internacionales y consultoría cloud.",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "Herramienta de estimación y comparación de precios de VMs en tiempo real para principales proveedores cloud. Ayuda a optimizar costos de infraestructura cloud (Azure, AWS, GCP).",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "Aplicación de escritorio moderna para gestionar clusters Kubernetes con claridad. Soporte multi-contexto, logs en tiempo real, terminales interactivos. Construida con Tauri y Rust.",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "Arquitectura Multi-Cloud"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "Landing Zones"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "Machine Learning", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["Liderazgo", "Gestión de equipos", "Gestión de proyectos", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Certificaciones Azure (532, 533, 534)" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS Telecomunicaciones Infraestructura Redes (Máster)",
        school: "Universidad de Lille 1 (Ciencias y Tecnologías)"
      },
      {
        year: "2002",
        degree: "Pasantía de 6 meses en EE.UU.",
        school: "Echo Web - Oregón"
      },
      {
        year: "2014",
        degree: "Gestión",
        school: "Formación profesional"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - Proyecto datacenter y virtualización",
      "VMWorld Europe 2016 - Mejor premio por cloud privado y automatización",
      "22 años de experiencia en infraestructura y cloud",
      "Incubación Euratech 2024",
      "Aceleración Euratech Cyber Campus 2025",
      "316+ estrellas en el proyecto Kexa (GitHub)",
      "1K+ seguidores LinkedIn",
      "Fundador de varias startups innovadoras"
    ],

    interests: [
      "Funboard",
      "Wing foil",
      "Paddle",
      "Creación de casas rurales turísticas",
      "Cine"
    ]
  },

  de: {
    name: "Patrick Szymkowiak",
    title: "Manager / Hybrid-Infrastruktur-Architekt",
    location: "Lille, Hauts-de-France, Frankreich",
    description: "Ich bin ein Ingenieur, der von technologischer Innovation begeistert ist und sich auf die Lösung komplexer Probleme und die Leitung strategischer Projekte spezialisiert hat. Meine kollaborative Führung und Kommunikationsfähigkeiten ermöglichen es mir, multidisziplinäre Teams um gemeinsame Ziele zu vereinen, um den Erfolg jedes Projekts zu gewährleisten.",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "Juni 2017 - Heute",
        role: "CEO / Cloud-Spezialist / Infrastruktur",
        company: "InnovTech",
        description: [
          "Gründung des Unternehmens InnovTech, Spezialist für Cloud-Provider-Reseller (Azure, AWS, GCP) in der Region Hauts-de-France",
          "Direkte Dienstleistungen für große internationale Kunden",
          "Entwicklung einer Open-Source-Lösung zur Infrastrukturüberprüfung in C#, Docker",
          "MCSE: Cloud Platform and Infrastructure; Azure-Zertifizierungen: 532, 534, 533",
          "MCT: Microsoft Teacher. Durchführung von Microsoft az-104 Schulungen"
        ]
      },
      {
        period: "2024 - Heute",
        role: "Gründer",
        company: "Startups kexa.io & thecloudprices.com",
        description: [
          "kexa.io: Überprüfung der IT-Sicherheit von Unternehmen",
          "thecloudprices.com: Preisschätzung für VMs von Cloud-Providern",
          "Euratech 2024 Inkubation - 6-monatiges Programm für kexa.io",
          "Euratech Cyber Campus 2025 Beschleunigung für kexa.io"
        ]
      },
      {
        period: "Januar 2023 - September 2024",
        role: "MLops",
        company: "Eurotunnel Kunde",
        description: [
          "Erstellung der Data-ML-Infrastruktur mit automatisiertem Terraform auf GitHub in CI/CD",
          "Azure OpenAI-Bereitstellung",
          "Implementierung einer Fahrzeugerkennungslösung Python, YOLO",
          "Implementierung eines Chatbots Python / Azure OpenAI",
          "Kafka-Implementierungsprojekt",
          "GitHub CI/CD Debugging. Verwaltung von Azure Scaleset Selfhosted Runner, cloud-init"
        ]
      },
      {
        period: "September 2021 - Oktober 2022",
        role: "Cloud-Teammanager",
        company: "Auchan Kunde",
        description: [
          "Verwaltung des Infrastrukturteams von 30 Personen",
          "Projektportfolio-Management",
          "Budgetverwaltung",
          "Management der Transformation zur Auslagerung von Verwaltungsdiensten"
        ]
      },
      {
        period: "November 2019 - 2021",
        role: "Migration zur Cloud",
        company: "Norauto International",
        description: [
          "Azure-Abonnementstart mit Erstellung von Terraform-Skripten. Landing Zone",
          "Erstellung der globalen Architektur",
          "Einrichtung gemeinsamer Infrastruktur für Datenprojekte",
          "Terraform, VM, Azure Databricks, PAAS PostgreSQL, Storage, Backup, Patches",
          "Arbeit an Datenthemen: Spark, Azure Data Factory, Azure Data Lake"
        ]
      },
      {
        period: "Februar 2018 - 2019",
        role: "Migration zur Cloud",
        company: "Auchan Retail International",
        description: [
          "Begleitung von 80 internationalen Projekten",
          "Erstellung der globalen Architektur",
          "Einrichtung gemeinsamer Infrastruktur",
          "Terraform, VM, Kubernetes, PAAS PostgreSQL MySQL, Storage, Backup, Patches"
        ]
      },
      {
        period: "Dez 2016 - Juni 2017",
        role: "Service Delivery Manager",
        company: "SwissLife France",
        description: [
          "Verantwortlich für ein Team von 17 Personen",
          "Level-2-Administration",
          "Datenbankdienst",
          "Produktionsteam, Bereitstellung"
        ]
      },
      {
        period: "2010 - Nov 2016",
        role: "Infrastrukturmanager",
        company: "SwissLife France",
        description: [
          "Rechenzentrum-Erstellungsprojekt, Virtualisierung von 200 Servern; VMworld Europe 2014",
          "Backup-Redesign-Projekt (TSM, Networker, Veeam, VDP VMware)",
          "Private-Cloud- und VRA-Automatisierungsprojekt; VMworld Europe 2016",
          "SAN-Infrastrukturprojekt / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "Monitoring-Redesign-Projekt (Zabbix, Linux)",
          "Messaging-Redesign-Projekt: Exchange 2013 für 6000 Konten",
          "Management von 2 Teams mit 11 Personen"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "Open-Source-Cloud-Alerting- und Monitoring-Plattform mit einfachen Regeln. IT-Sicherheitsüberprüfung für Unternehmen. 316+ GitHub-Sterne. Euratech 2024 Inkubation und Cyber Campus 2025 Beschleunigung.",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "InnovTech-Unternehmen - Spezialisierter Cloud-Provider-Reseller (Azure, AWS, GCP) in der Region Hauts-de-France. Direkte Dienstleistungen für internationale Großkunden und Cloud-Beratung.",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "Echtzeit-VM-Preisschätzungs- und Vergleichstool für große Cloud-Provider. Hilft bei der Optimierung der Cloud-Infrastrukturkosten (Azure, AWS, GCP).",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "Moderne Desktop-Anwendung zur übersichtlichen Verwaltung von Kubernetes-Clustern. Multi-Kontext-Unterstützung, Echtzeit-Protokolle, interaktive Terminals. Entwickelt mit Tauri und Rust.",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "Multi-Cloud-Architektur"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "Landing Zones"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "Machine Learning", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["Führung", "Teammanagement", "Projektmanagement", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Azure-Zertifizierungen (532, 533, 534)" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS Telekommunikation Infrastruktur Netzwerke (Master)",
        school: "Universität Lille 1 (Wissenschaft und Technologie)"
      },
      {
        year: "2002",
        degree: "6-monatiges Praktikum in den USA",
        school: "Echo Web - Oregon"
      },
      {
        year: "2014",
        degree: "Management",
        school: "Berufliche Weiterbildung"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - Rechenzentrum- und Virtualisierungsprojekt",
      "VMWorld Europe 2016 - Best Award für Private Cloud und Automatisierung",
      "22 Jahre Erfahrung in Infrastruktur und Cloud",
      "Euratech 2024 Inkubation",
      "Euratech Cyber Campus 2025 Beschleunigung",
      "316+ Sterne auf Kexa-Projekt (GitHub)",
      "1K+ LinkedIn-Follower",
      "Gründer mehrerer innovativer Startups"
    ],

    interests: [
      "Funboard",
      "Wing Foil",
      "Paddle",
      "Erstellung von touristischen Ferienhäusern",
      "Kino"
    ]
  },

  ja: {
    name: "Patrick Szymkowiak",
    title: "マネージャー / ハイブリッドインフラストラクチャアーキテクト",
    location: "リール、オー・ド・フランス、フランス",
    description: "私は技術革新に情熱を持つエンジニアで、複雑な問題の解決と戦略的プロジェクトのリードを専門としています。私の協力的なリーダーシップとコミュニケーションスキルにより、多分野のチームを共通の目標に向けて統合し、各プロジェクトの成功を確実にすることができます。",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "2017年6月 - 現在",
        role: "CEO / クラウドスペシャリスト / インフラストラクチャ",
        company: "InnovTech",
        description: [
          "オー・ド・フランス地域でクラウドプロバイダー再販業者（Azure、AWS、GCP）を専門とするInnovTechの設立",
          "大規模国際アカウントへの直接サービス",
          "C#、Dockerでのインフラストラクチャ検証オープンソースソリューションの開発",
          "MCSE：クラウドプラットフォームとインフラストラクチャ、Azure認定：532、534、533",
          "MCT：マイクロソフト認定トレーナー。Microsoft az-104トレーニングの実施"
        ]
      },
      {
        period: "2024年 - 現在",
        role: "創業者",
        company: "スタートアップ kexa.io & thecloudprices.com",
        description: [
          "kexa.io：企業の情報システムセキュリティ検証",
          "thecloudprices.com：クラウドプロバイダーのVM価格見積もり",
          "Euratech 2024インキュベーション - kexa.ioの6ヶ月プログラム",
          "Euratech Cyber Campus 2025アクセラレーション for kexa.io"
        ]
      },
      {
        period: "2023年1月 - 2024年9月",
        role: "MLops",
        company: "ユーロトンネルクライアント",
        description: [
          "CI/CDでGitHub上の自動化されたTerraformを使用したデータMLインフラストラクチャの作成",
          "Azure OpenAIのデプロイメント",
          "Python、YOLOを使用した車両認識ソリューションの実装",
          "Python / Azure OpenAIチャットボットの実装",
          "Kafka実装プロジェクト",
          "GitHub CI/CDのデバッグ。Azure Scaleset Selfhosted Runner、cloud-initの管理"
        ]
      },
      {
        period: "2021年9月 - 2022年10月",
        role: "クラウドチームマネージャー",
        company: "オーシャンクライアント",
        description: [
          "30名のインフラストラクチャチームの管理",
          "プロジェクトポートフォリオ管理",
          "支出予算管理",
          "管理サービスのアウトソーシング変革の管理"
        ]
      },
      {
        period: "2019年11月 - 2021年",
        role: "クラウド移行",
        company: "Norauto International",
        description: [
          "Terraformスクリプト作成によるAzureサブスクリプション開始。ランディングゾーン",
          "グローバルアーキテクチャの作成",
          "データプロジェクト向け共有インフラストラクチャのセットアップ",
          "Terraform、VM、Azure Databricks、PAAS PostgreSQL、ストレージ、バックアップ、パッチ",
          "データテーマでの作業：Spark、Azure Data Factory、Azure Data Lake"
        ]
      },
      {
        period: "2018年2月 - 2019年",
        role: "クラウド移行",
        company: "Auchan Retail International",
        description: [
          "80の国際プロジェクトのサポート",
          "グローバルアーキテクチャの作成",
          "共有インフラストラクチャのセットアップ",
          "Terraform、VM、Kubernetes、PAAS PostgreSQL MySQL、ストレージ、バックアップ、パッチ"
        ]
      },
      {
        period: "2016年12月 - 2017年6月",
        role: "サービスデリバリーマネージャー",
        company: "SwissLife France",
        description: [
          "17名のチームの責任者",
          "レベル2管理",
          "データベースサービス",
          "プロダクションチーム、デプロイメント"
        ]
      },
      {
        period: "2010年 - 2016年11月",
        role: "インフラストラクチャマネージャー",
        company: "SwissLife France",
        description: [
          "データセンター作成プロジェクト、200台のサーバーの仮想化; VMworld Europe 2014",
          "バックアップ再設計プロジェクト（TSM、Networker、Veeam、VDP VMware）",
          "プライベートクラウドおよびVRA自動化プロジェクト; VMworld Europe 2016",
          "SANインフラストラクチャプロジェクト / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "監視再設計プロジェクト（Zabbix、Linux）",
          "メッセージング再設計プロジェクト：6000アカウント用のExchange 2013",
          "11名の2チームの管理"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "シンプルなルールを持つオープンソースクラウドアラート・監視プラットフォーム。企業のIT セキュリティ検証。GitHub 316+スター。Euratech 2024インキュベーションとCyber Campus 2025アクセラレーション。",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "InnovTech社 - オー・ド・フランス地域のクラウドプロバイダー専門リセラー（Azure、AWS、GCP）。国際大口顧客への直接サービスとクラウドコンサルティング。",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "主要クラウドプロバイダーのリアルタイムVM価格見積もりと比較ツール。クラウドインフラストラクチャコストの最適化を支援（Azure、AWS、GCP）。",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "Kubernetesクラスターを明確に管理する最新デスクトップアプリケーション。マルチコンテキストサポート、リアルタイムログ、対話型ターミナル。TauriとRustで構築。",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "マルチクラウドアーキテクチャ"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "ランディングゾーン"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "機械学習", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["リーダーシップ", "チーム管理", "プロジェクト管理", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Azure認定（532、533、534）" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS 通信インフラストラクチャネットワーク（修士号）",
        school: "リール第1大学（科学技術）"
      },
      {
        year: "2002",
        degree: "米国での6ヶ月インターンシップ",
        school: "Echo Web - オレゴン"
      },
      {
        year: "2014",
        degree: "マネジメント",
        school: "専門職業訓練"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - データセンターと仮想化プロジェクト",
      "VMWorld Europe 2016 - プライベートクラウドと自動化のベストアワード",
      "インフラストラクチャとクラウドでの22年の経験",
      "Euratech 2024インキュベーション",
      "Euratech Cyber Campus 2025アクセラレーション",
      "Kexaプロジェクト（GitHub）で316以上のスター",
      "LinkedInフォロワー1K以上",
      "複数の革新的なスタートアップの創業者"
    ],

    interests: [
      "ファンボード",
      "ウィングフォイル",
      "パドル",
      "観光コテージの作成",
      "映画"
    ]
  },

  zh: {
    name: "Patrick Szymkowiak",
    title: "经理 / 混合基础设施架构师",
    location: "里尔，上法兰西，法国",
    description: "我是一名对技术创新充满热情的工程师，专门解决复杂问题和领导战略项目。我的协作领导能力和沟通技巧使我能够将多学科团队团结在共同目标周围，确保每个项目的成功。",

    contact: {
      email: "contact@4urcloud.eu",
      linkedin: "https://www.linkedin.com/in/patrick-szymkowiak",
      github: "https://github.com/pszymkowiak",
      website: "https://www.4urcloud.eu",
      gites: "https://www.lamadraguedes2caps.fr"
    },

    experience: [
      {
        period: "2017年6月 - 至今",
        role: "CEO / 云专家 / 基础设施",
        company: "InnovTech",
        description: [
          "在上法兰西地区创建专门从事云提供商经销商（Azure、AWS、GCP）的公司InnovTech",
          "为大型国际客户提供直接服务",
          "开发C#、Docker的开源基础设施验证解决方案",
          "MCSE：云平台和基础设施；Azure认证：532、534、533",
          "MCT：微软认证培训师。提供Microsoft az-104培训"
        ]
      },
      {
        period: "2024年 - 至今",
        role: "创始人",
        company: "初创公司 kexa.io & thecloudprices.com",
        description: [
          "kexa.io：企业信息系统安全验证",
          "thecloudprices.com：云提供商VM价格估算",
          "Euratech 2024孵化 - kexa.io的6个月项目",
          "Euratech网络校园2025加速计划 for kexa.io"
        ]
      },
      {
        period: "2023年1月 - 2024年9月",
        role: "MLops",
        company: "欧洲隧道客户",
        description: [
          "在GitHub上使用自动化Terraform创建数据ML基础设施（CI/CD）",
          "部署Azure OpenAI",
          "实施车辆识别解决方案Python、YOLO",
          "实施聊天机器人Python / Azure OpenAI",
          "Kafka实施项目",
          "调试GitHub CI/CD。管理Azure Scaleset自托管运行器、cloud-init"
        ]
      },
      {
        period: "2021年9月 - 2022年10月",
        role: "云团队经理",
        company: "欧尚客户",
        description: [
          "管理30人的基础设施团队",
          "项目组合管理",
          "支出预算管理",
          "管理服务外包转型管理"
        ]
      },
      {
        period: "2019年11月 - 2021年",
        role: "云迁移",
        company: "Norauto International",
        description: [
          "通过创建Terraform脚本启动Azure订阅。登陆区",
          "创建全球架构",
          "为数据项目设置共享基础设施",
          "Terraform、VM、Azure Databricks、PAAS PostgreSQL、存储、备份、补丁",
          "数据主题工作：Spark、Azure Data Factory、Azure Data Lake"
        ]
      },
      {
        period: "2018年2月 - 2019年",
        role: "云迁移",
        company: "Auchan Retail International",
        description: [
          "支持80个国际项目",
          "创建全球架构",
          "设置共享基础设施",
          "Terraform、VM、Kubernetes、PAAS PostgreSQL MySQL、存储、备份、补丁"
        ]
      },
      {
        period: "2016年12月 - 2017年6月",
        role: "服务交付经理",
        company: "SwissLife France",
        description: [
          "负责17人团队",
          "二级管理",
          "数据库服务",
          "生产团队、部署"
        ]
      },
      {
        period: "2010年 - 2016年11月",
        role: "基础设施经理",
        company: "SwissLife France",
        description: [
          "数据中心创建项目，虚拟化200台服务器；VMworld Europe 2014",
          "备份重新设计项目（TSM、Networker、Veeam、VDP VMware）",
          "私有云和VRA自动化项目；VMworld Europe 2016",
          "SAN基础设施项目 / VMware 3.5 -> 4.0 -> 5.5 -> 6.0",
          "监控重新设计项目（Zabbix、Linux）",
          "消息传递重新设计项目：为6000个账户部署Exchange 2013",
          "管理2个11人团队"
        ]
      }
    ],

    projects: [
      {
        name: "Kexa.io",
        description: "具有简单规则的开源云警报和监控平台。企业信息系统安全验证。GitHub 316+星标。Euratech 2024孵化和Cyber Campus 2025加速。",
        technologies: ["TypeScript", "Docker", "Kubernetes", "GitHub Actions", "Grafana"],
        github: "https://github.com/kexa-io/Kexa",
        website: "https://www.kexa.io",
        image: "/screenshots/kexa.png",
        stars: 316,
        forks: 11,
        license: "Apache-2.0"
      },
      {
        name: "4urCloud.eu",
        description: "InnovTech公司 - 上法兰西地区专业云提供商经销商（Azure、AWS、GCP）。为国际大客户提供直接服务和云咨询。",
        technologies: ["Azure", "AWS", "GCP", "Cloud Consulting"],
        website: "https://www.4urcloud.eu",
        image: "/screenshots/4urcloud.png"
      },
      {
        name: "TheCloudPrices.com",
        description: "主要云提供商的实时VM价格估算和比较工具。帮助优化云基础设施成本（Azure、AWS、GCP）。",
        technologies: ["Cloud", "Pricing", "Cost Optimization"],
        website: "https://www.thecloudprices.com",
        image: "/screenshots/thecloudprices.png"
      },
      {
        name: "kScratch.app",
        description: "清晰管理Kubernetes集群的现代桌面应用程序。多上下文支持、实时日志、交互式终端。使用Tauri和Rust构建。",
        technologies: ["Tauri", "Rust", "Kubernetes", "Desktop App"],
        github: "https://github.com/kexa-io/kscratch",
        website: "https://www.kscratch.app",
        image: "/screenshots/kscratch.png"
      }
    ],

    skills: {
      cloud: ["Azure", "AWS", "GCP", "多云架构"],
      infrastructure: ["Terraform", "Kubernetes", "Docker", "VMware", "登陆区"],
      data: ["Azure Databricks", "Apache Spark", "Azure Data Factory", "Kafka", "PostgreSQL", "MySQL"],
      ai: ["Azure OpenAI", "机器学习", "Python", "YOLO"],
      devops: ["CI/CD", "GitHub Actions", "Git", "Ansible"],
      monitoring: ["Grafana", "Zabbix", "Prometheus"],
      programmation: ["TypeScript", "C#", "Python", "PHP", "Java", "Perl"],
      management: ["领导力", "团队管理", "项目管理", "ITIL"]
    },

    certifications: [
      { year: "2025", name: "AWS Practitioner" },
      { year: "2024", name: "Google Cloud Platform (GCP)" },
      { year: "2024", name: "Azure Data Engineer Associate" },
      { year: "2018", name: "Microsoft Certified Trainer (MCT) - Cloud Azure" },
      { year: "2017", name: "MCSE: Cloud Platform and Infrastructure" },
      { year: "2017", name: "MCSA: Cloud Azure Platform" },
      { year: "2017", name: "Azure认证（532、533、534）" },
      { year: "2014", name: "ITIL Foundation" }
    ],

    education: [
      {
        year: "2001",
        degree: "DESS 电信基础设施网络（硕士学位）",
        school: "里尔第一大学（科学与技术）"
      },
      {
        year: "2002",
        degree: "美国6个月实习",
        school: "Echo Web - 俄勒冈"
      },
      {
        year: "2014",
        degree: "管理",
        school: "专业培训"
      }
    ],

    achievements: [
      "VMWorld Europe 2014 - 数据中心和虚拟化项目",
      "VMWorld Europe 2016 - 私有云和自动化最佳奖",
      "基础设施和云领域22年经验",
      "Euratech 2024孵化",
      "Euratech网络校园2025加速",
      "Kexa项目（GitHub）316+星标",
      "LinkedIn 1K+关注者",
      "多个创新创业公司的创始人"
    ],

    interests: [
      "趣味板",
      "翼箔",
      "桨板",
      "创建旅游小屋",
      "电影"
    ]
  }
};

// Hook pour utiliser les données de profil traduites
export const useProfileTranslations = (language: Language): ProfileData => {
  return profileTranslations[language];
};
